<template>
  <div class="recruiter">
    <b-card no-body class="p-4 rounded-0 shadow-none">
      <v-wait :for="loaderName">
        <template slot="waiting">
          <HalfCircleSpinner />
          <div class="spinner-message my-3 text-center">
            Loading data...
          </div>
        </template>
        <!-- <h2 class="my-3 v2_font_size_20 v2_color_black">
        RECRUITER INFO/FAQ PAGE
        </h2> -->
        <div>
          <recruiter-accordion />
        </div>
      </v-wait>
    </b-card>
  </div>
</template>
<script>
import { HalfCircleSpinner } from 'epic-spinners';
import RecruiterAccordion from "@/components/recruiter/faq/RecruiterAccordion";

export default {
  name: 'RecruiterFaq',
  components: {
    HalfCircleSpinner,
    RecruiterAccordion
  },
  computed: {
    loaderName: function () {
      return this.$options.name + '_loading';
    },
  },
};
</script>

<style scoped />
